// Port of PROTO leaving.html (BRIEF P4). Shared PAGE_CSS rules used here
// (.prose, .narrow, hr.rule-ink, .wrap, .section) already live in
// ../../styles/site.css (build-plan R6); only `.lv-steps` (the numbered
// list) is page-specific and lives in LeavingPage.css.
import { useRef } from 'react';
import { Opener } from '../Opener.js';
import { useReveal } from '../motion.js';
import './LeavingPage.css';

const STEPS = [
  'If your expectations aren’t being met or if you encounter an issue, we appreciate it when you take responsibility and address it before considering leaving the clan. Clan leadership is here to help. We understand this can be challenging, but open communication is crucial, especially before making significant decisions like departing. It feels like a missed opportunity and leaves a sense of disappointment if situations don’t get the chance to be resolved. Often there are solutions we can work out together.',
  'We really appreciate it when you let clan leadership know about your intention to leave the clan before actually doing so. After playing together for some time, it’s never fun to be surprised by someone’s sudden departure.',
  'Once you leave it’s appreciated to wave goodbye to clan members and thank them for the fun times shared. We suggest to drop a message in discord elaborating on your decision to go our own separate ways.',
  'Don’t be a stranger. Feel free to drop by on our discord.',
];

export function LeavingPage() {
  const ref = useRef<HTMLDivElement | null>(null);
  useReveal(ref);

  return (
    <div className="lv-page" ref={ref}>
      <Opener lines={['Ending your', 'clan membership']} />
      <section className="wrap section">
        <div className="prose big narrow" data-reveal>
          <p>
            Sometimes it happens that people wish to plot a new or different course. That is alright. We feel
            everyone is free to go as they please. There are good ways to leave, there are bad ways to leave. We
            hope to stay on good terms once we go our separate ways. Below you will find our ideas about how we
            can do that.
          </p>
          <h2>How we hope to stay on good terms as we go our separate ways</h2>
        </div>
        <ol className="lv-steps narrow">
          {STEPS.map((text, i) => (
            <li data-reveal key={i}>
              <span className="sn">{i + 1}</span>
              <p>{text}</p>
            </li>
          ))}
        </ol>
      </section>
    </div>
  );
}
